// Keyboard Validation Helpers
window.isNumberValidate = function(e) {
    var charCode = (e = e || window.event).which || e.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57 || charCode > 107 || charCode > 219 || charCode > 221) && charCode != 40 && charCode != 32 && charCode != 41 && (charCode < 43 || charCode > 46));
};

window.isAlfa = function(e) {
    var charCode = (e = e || window.event).which || e.keyCode;
    return !(charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122));
};

export function initLandingExpertForm() {
    const form = document.querySelector(".landing-software-expert-wrapper form, form.comment-form");
    if (!form) return;

    form.addEventListener("submit", async function(e) {
        e.preventDefault();
        let isValid = true;

        // 1. Reset error classes and status messages
        form.querySelectorAll(".form-group").forEach(group => {
            group.classList.remove("enabled-error");
        });

        const successMsg = form.querySelector(".form-error-text-wrapper span.contact-success-text, .form-error-text-wrapper span.success-text");
        const errorMsg = form.querySelector(".form-error-text-wrapper span.contact-error-text, .form-error-text-wrapper span.error-text");

        if (successMsg) successMsg.classList.remove("active");
        if (errorMsg) errorMsg.classList.remove("active");

        // 2. Validate all required text inputs (excluding hidden, buttons, and optional phone)
        form.querySelectorAll("input").forEach(input => {
            const val = input.value.trim();
            const id = input.id;
            const type = input.getAttribute("type");
            const name = input.getAttribute("name");

            if (type === "hidden" || type === "submit" || type === "button" || !name || id === "ld_banner_phone") {
                return;
            }

            if (val === "") {
                isValid = false;
                const group = input.closest(".form-group");
                if (group) {
                    group.classList.add("enabled-error");
                }
            }
        });

        // 3. Validate Selects (Country dropdown)
        form.querySelectorAll("select").forEach(select => {
            const val = (typeof jQuery !== 'undefined') ? jQuery(select).val() : select.value;
            if (!val || val.trim() === "") {
                isValid = false;
                const group = select.closest(".form-group");
                if (group) {
                    group.classList.add("enabled-error");
                }
            }
        });

        // 4. Validate Textareas (Message / Description)
        form.querySelectorAll("textarea").forEach(textarea => {
            const val = textarea.value.trim();
            if (val === "") {
                isValid = false;
                const group = textarea.closest(".form-group");
                if (group) {
                    group.classList.add("enabled-error");
                }
            }
        });

        // 5. Validate Email (Empty & Regex Format)
        const emailInput = form.querySelector("input#ld_banner_email, input[name='ld_banner_email']");
        const emailRegex = /^([\w.+]{1,})([^\W])(@)([\w]{1,})(\.[\w]{1,})+$/;

        if (emailInput) {
            const emailVal = emailInput.value.trim();
            const group = emailInput.closest(".form-group");
            const errSpan = group ? group.querySelector(".error-text") : null;

            if (emailVal === "") {
                isValid = false;
                if (group) group.classList.add("enabled-error");
                if (errSpan) errSpan.textContent = "Please enter your Email";
            } else if (!emailRegex.test(emailVal)) {
                isValid = false;
                if (group) group.classList.add("enabled-error");
                if (errSpan) errSpan.textContent = "Please enter valid Email";
            }
        }

        // 6. Validate Phone (Optional, but checks regex format if entered)
        const phoneInput = form.querySelector("input#ld_banner_phone, input[name='ld_banner_phone']");
        const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

        if (phoneInput) {
            const phoneVal = phoneInput.value.trim();
            const group = phoneInput.closest(".form-group");
            const errSpan = group ? group.querySelector(".error-text") : null;

            if (phoneVal !== "" && !phoneRegex.test(phoneVal)) {
                isValid = false;
                if (group) group.classList.add("enabled-error");
                if (errSpan) errSpan.textContent = "Please enter valid Phone";
            }
        }

        // Stop submission if form is invalid
        if (!isValid) {
            return false;
        }

        // 7. AJAX Form Submission
        const submitBtnWrapper = form.querySelector(".submit-btn-wrapper");
        const loader = form.querySelector(".ajax-loader");

        if (submitBtnWrapper) submitBtnWrapper.classList.add("active");
        if (loader) loader.classList.add("active");

        const formData = new FormData(form);
        const actionUrl = form.getAttribute("action");

        try {
            const response = await fetch(actionUrl, {
                method: "POST",
                body: formData
            });

            const result = await response.json();

            if (result.success == 1 || result.success === true) {
                form.reset();
                form.querySelectorAll(".form-group").forEach(group => {
                    group.classList.remove("enabled-error");
                });

                if (result.redirect) {
                    window.location.href = result.redirect;
                } else if (successMsg) {
                    successMsg.classList.add("active");
                }
            } else {
                if (errorMsg) errorMsg.classList.add("active");
            }
        } catch (error) {
            console.error("Submission failed:", error);
            if (errorMsg) errorMsg.classList.add("active");
        } finally {
            if (submitBtnWrapper) submitBtnWrapper.classList.remove("active");
            if (loader) loader.classList.remove("active");
        }
    });
}
